module.exports = __webpack_public_path__ + "img/sap_token.gr.e694a73.png";